










import { Vue, Component, Prop } from "vue-property-decorator";
import ModalBase from '@/components/ModalBase.vue';

@Component({
  components: {
    ModalBase
  }
})
export default class UpsellModal extends Vue {}
